<div class="container-fluid">
  <div class="row">
    @for (tab of config; track tab.link) {
      @if (tab.visible === undefined || tab.visible) {
        <a
          class="custom-col text-center"
          routerLink="{{ tab.link }}"
          routerLinkActive
          #rla="routerLinkActive"
          [class.active]="rla.isActive"
          [routerLinkActiveOptions]="{exact: tab.exact}"
          [class.text-muted]="!rla.isActive"
          [class.text-body]="rla.isActive"
        >
          {{ tab.translationKey | translate }}
        </a>
      }
    }
    <ng-content></ng-content>
  </div>
</div>
